import React, { useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import PayrollEmployees from './PayrollEmployees';
import PayrollProcess from './PayrollProcess';
import './Payroll.css';

export default function Payroll() {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('process');

  if (user?.email !== 'appleridge158@gmail.com') {
    return <div style={{padding:'40px', textAlign:'center', color:'#888'}}>Access restricted.</div>;
  }

  return (
    <div className="pr-container">
      <div className="pr-header">
        <h1 style={{margin:0, fontSize:'1.6rem', color:'#2c3e50'}}>💰 Payroll</h1>
      </div>

      <div className="pr-tabs">
        <button className={`pr-tab ${activeTab === 'process' ? 'active' : ''}`} onClick={() => setActiveTab('process')}>
          Process Payroll
        </button>
        <button className={`pr-tab ${activeTab === 'employees' ? 'active' : ''}`} onClick={() => setActiveTab('employees')}>
          Employee Settings
        </button>
      </div>

      {activeTab === 'process' ? <PayrollProcess /> : <PayrollEmployees />}
    </div>
  );
}
